export const TOKEN_TYPE = 'Token '
export const REQUEST_HEADER_AUTH_KEY = 'Authorization'
